interface InputProps {
  inputId: number;
  input: { input: string; type: string; name: string };
  defaultValue?: string;
  allowedFileExtensions?: string;
}

export const createInput = ({
  inputId,
  input,
  defaultValue = "",
  allowedFileExtensions
}: InputProps): string => {
  const commonStyles =
    "position: relative; width: 100%; height: 100%; box-sizing: border-box;";

  const fitTextHandler = `if(this.checked){this.Defultv='True';}else{this.Defultv='False';}`;

  const wrapperStyles =
    "display: inline-block; max-width:100%; resize: both; height:50px; width:50px; position: relative;";

  const wrapper = `<div 
    id="input-wrapper-${inputId}" 
    class="wrapper" 
    data-type="${input.type}" 
    contenteditable="false" 
    style="${wrapperStyles}" 
    oninput="event.preventDefault();"
  >`;

  const topBar = `
  <div class="top-bar" style="
    // position: absolute;
    top: -18px;
    left: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    z-index: 200;
    white-space: nowrap;
    background: hsl(var(--primary));;
    color: white;
    padding: 2px 6px;
    border-radius: 6px;
    cursor: default;
  ">
    
    <div 
      title="${input.name}"
      style="
        font-weight: 500;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      "
    >
      ${input.name}
    </div>
  </div>
`;

  const getInputElement = (): string => {
    switch (input.type) {
      case "editor":
        return `<div 
          id="${inputId}"
          data-name="${input.name}"
          data-input-type="${input.type}" 
          style="
            border: 1px solid #ccc;
            ${commonStyles}
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          editor
        </div>`;
      case "long-text":
        return `<textarea 
          id="${inputId}"
          data-name="${input.name}"
          data-input-type="${input.type}" 
          data-fit-text="false"
          disabled
          style="${commonStyles} resize: none;"
          data-textarea="true"
        >${defaultValue}</textarea>`;

      case "select":
        return `<select 
          id="${inputId}"
          data-name="${input.name}"
          data-input-type="${input.type}" 
          disabled
          style="${commonStyles}"
        >
          <option value="${defaultValue}">${defaultValue}</option>
        </select>`;

      case "date":
        return `<input 
          id="${inputId}"
          data-name="${input.name}"
          type="text"
          value="${defaultValue}"
          data-input-type="${input.type}" 
          data-jdp
          data-jdp-only-date
          disabled
          style="${commonStyles}" 
        />`;

      case "price":
        return `<input 
          id="${inputId}"
          data-name="${input.name}"
          type="text"
          value="${defaultValue}"
          data-input-type="${input.type}"
          disabled
          style="${commonStyles}" 
        />
        <span style="font-size:12px;">0 تومان</span>`;

      case "image-preview":
        return `<input 
          id="${inputId}"
          data-name="${input.name}"
          type="file"
          data-input-type="${input.type}"
          disabled image-preview="true"
          style="${commonStyles}" 
        />
        <img id="${inputId}" alt="Image Preview" />`;

      case "file":
        return `<input 
          id="${inputId}"
          data-name="${input.name}"
          type="file"
          data-input-type="${input.type}"
          ${allowedFileExtensions
            ? `data-allowed-extensions="${allowedFileExtensions}" accept="${allowedFileExtensions
              .split(",")
              .map((ext) => `.${ext.trim()}`)
              .join(",")}"`
            : ""
          }
          disabled
          style="${commonStyles}" 
        />`;
      case "range":
        return `<input 
          id="${inputId}"
          data-name="${input.name}"
          type="number"
          step="0.0001"
          value="${defaultValue}"
          data-input-type="${input.type}"
          disabled
          style="${commonStyles}" 
        />`;

      default:
        return `<input 
          id="${inputId}"
          data-name="${input.name}"
          type="${input.input}"
          value="${defaultValue}"
          data-input-type="${input.type}"
          disabled
          style="${commonStyles}" 
        />`;
    }
  };

  return wrapper + topBar + getInputElement() + "</div>";
};
